import { Component, input, output } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { EntityLabelPipe } from '../entity-label.pipe';
import { CustomFormGroup, PricingEntity } from '../../shared';

@Component({
    selector: 'app-custom-pricing-list',
    templateUrl: './custom-pricing-list.component.html',
    styleUrls: ['./custom-pricing-list.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, EntityLabelPipe],
})
export class CustomPricingListComponent {
    readonly customPricingList = input.required<FormArray<CustomFormGroup>>();
    readonly pricingEntities = input.required<PricingEntity[]>();
    readonly testId = input.required<string>();
    readonly editCustom = output<number>();
    readonly removeCustom = output<number>();
}
